import { ToothEndodonticInput } from '../../../../graphql/graphql';

interface IconValues {
	src: string;
	tooltip: string;
}

// TODO: icons to CDN !!!
export const ENDODONTIC_ICONS: Record<keyof ToothEndodonticInput, IconValues> =
	{
		cold: {
			src: 'https://cdn.meddi.com/DENT/endodontic/cold.png',
			tooltip: 'patientTreatment.meddiDENT.dentalCross.endodontic.cold',
		},
		heat: {
			src: 'https://cdn.meddi.com/DENT/endodontic/heat.png',
			tooltip: 'patientTreatment.meddiDENT.dentalCross.endodontic.heat',
		},
		electric: {
			src: 'https://cdn.meddi.com/DENT/endodontic/electricity.png',
			tooltip: 'patientTreatment.meddiDENT.dentalCross.endodontic.electric',
		},
		palpation: {
			src: 'https://cdn.meddi.com/DENT/endodontic/palpation.png',
			tooltip: 'patientTreatment.meddiDENT.dentalCross.endodontic.palpation',
		},
		percussion: {
			src: 'https://cdn.meddi.com/DENT/endodontic/percussion.png',
			tooltip: 'patientTreatment.meddiDENT.dentalCross.endodontic.percussion',
		},
	};
